import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1, Paragraph, Input, Textarea, LinkButton,
} from '../../components/typography';
import { Table, Td } from '../../components/tables';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';

class StilEtSpoergsmaal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navn: '',
      email: '',
      telefon: '',
      emne: '',
      besked: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const {
      navn,
      email,
      telefon,
      emne,
      besked,
    } = this.state;
    if (besked.trim() === '') {
      this.setState({ error: 'Indtast venligst en besked' });
      return;
    }
    this.setState({ isLoading: true, error: null });
    window.axios.post('/api/contact', { // eslint-disable-line
      navn,
      email,
      telefon,
      emne,
      besked,
    }).then(
      () => {
        this.setState({ isLoading: false, success: true });
      },
    ).catch(
      () => {
        this.setState({ isLoading: false, error: 'Kunne ikke sende beskeden' });
      },
    );
  }

  handleChange({ target: { value, name } }) {
    this.setState({ [name]: value });
  }

  render() {
    const {
      navn,
      email,
      telefon,
      emne,
      besked,
      isLoading,
      success,
      error,
    } = this.state;
    return (
      <Row>
        <Col xs={12}>
          <Heading1>FAQ - Stil et spørgsmål</Heading1>
          <Paragraph>
            Vi sætter stor pris på din hjælp.
            Send gerne spørgsmål, kritik m.m. ind til os.
            En del af spørgsmålene vil blive sat ind med svar på FAQ siden(Personlige oplysninger vil IKKE indgå på siden).
            Hvis du ønsker direkte respons så indsæt venligst din email eller dit telefonnummer.
          </Paragraph>
          <Row>
            <Col xs={12} sm={12} md={8} lg={4}>
              <Table lines1>
                <tbody>
                  <tr>
                    <Td bold>
                      Navn:
                    </Td>
                    <Td textRight>
                      <Input type="text" name="navn" value={navn} onChange={this.handleChange} />
                    </Td>
                  </tr>
                  <tr>
                    <Td bold>
                      Email:
                    </Td>
                    <Td textRight>
                      <Input type="text" name="email" value={email} onChange={this.handleChange} />
                    </Td>
                  </tr>
                  <tr>
                    <Td bold>
                      Telefon:
                    </Td>
                    <Td textRight>
                      <Input type="text" name="telefon" value={telefon} onChange={this.handleChange} />
                    </Td>
                  </tr>
                  <tr>
                    <Td bold>
                      Emne:
                    </Td>
                    <Td textRight>
                      <Input type="text" name="emne" value={emne} onChange={this.handleChange} />
                    </Td>
                  </tr>
                  <tr>
                    <Td bold verticalTop>
                      Besked*:
                    </Td>
                    <Td textRight>
                      <Textarea height="80px" value={besked} name="besked" onChange={this.handleChange} />
                    </Td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col xs={12}>
              <LinkButton action onClick={this.onClick} disabled={success} spinCog={isLoading}>
                Send
              </LinkButton>
              {success && (
                <Paragraph green>
                  Dit spørgsmål er sendt.
                </Paragraph>
              )}
              {error && (
                <Paragraph red>
                  {error}
                </Paragraph>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="FAQ">
    <Container white>
      <StilEtSpoergsmaal />
    </Container>
  </SidemenuLayout>
);
